import axios from "axios";
import type { DigitalAssetAppleCategory } from "../types";
const API_BASE_URL = process.env.REACT_APP_API_BASEURL + "/DigitalAssets";

export const getDigitalAssetAppleCategories = async () => {
  const { data } = await axios.get<DigitalAssetAppleCategory[]>(
    `${API_BASE_URL}/GetDigitalAssetAppleCategories`,
  );

  return data;
};
